import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';




export const getStatusSteps = createAsyncThunk(
  '/getStatusSteps',
  async (id) => {
    const response = await axios.get(`/GetStatusSteps/${id}`);
    return response.data;
  }
);

export const getNewWorkOrderCreateSteps = createAsyncThunk(
  '/getNewWorkOrderCreateSteps',
  async (id) => {
    const response = await axios.get(`/GetNewWorkOrderCreateSteps/${id}`);
    return response.data;
  }
);

export const getPaymentRules = createAsyncThunk(
  '/getPaymentRules',
  async () => {
    const response = await axios.get(`/GetPaymentRules`);
    return response.data;
  }
);
export const getChangeStatusSteps = createAsyncThunk(
  '/getChangeStatusSteps',
  async (id) => {
    const response = await axios.get(`/GetChangeStatusSteps/${id}`);
    return response.data;
  }
);


export const getStatusUserTypes = createAsyncThunk(
  '/getStatusUserTypes',
  async (id) => {
    const response = await axios.get(`/GetStatusUserTypes/${id}`);
    return response.data;
  }
);

export const getStatusMailUserTypes = createAsyncThunk(
  '/getStatusMailUserTypes',
  async (id) => {
    const response = await axios.get(`/GetStatusMailUserTypes/${id}`);
    return response.data;
  }
);

export const getChangeStatusUserTypes = createAsyncThunk(
  '/getChangeStatusUserTypes',
  async (id) => {
    const response = await axios.get(`/GetChangeStatusUserTypes/${id}`);
    return response.data;
  }
);

export const setStatusSteps = createAsyncThunk(
  '/setStatusSteps',
  async (Id) => {

    const response = await axios.get(`/SetStatusSteps/${Id}`);
    return response.data;
  }
);

export const setNewWorkOrderCreateSteps = createAsyncThunk(
  '/setNewWorkOrderCreateSteps',
  async (Id) => {

    const response = await axios.get(`/SetNewWorkOrderCreateSteps/${Id}`);
    return response.data;
  }
);
export const setPaymentRules = createAsyncThunk(
  '/setPaymentRules',
  async (Id) => {

    const response = await axios.get(`/setPaymentRules/${Id[0]}/${Id[1]}`);
    return response.data;
  }
);
export const setChangeStatusSteps = createAsyncThunk(
  '/setChangeStatusSteps',
  async (Id) => {

    const response = await axios.get(`/setChangeStatusSteps/${Id}`);
    return response.data;
  }
);

export const setStatusUserTypes = createAsyncThunk(
  '/setStatusUserTypes',
  async (Id) => {
    const response = await axios.get(`/SetStatusUserTypes/${Id}`);
    return response.data;
  }
);

export const setStatusMailUserTypes = createAsyncThunk(
  '/setStatusMailUserTypes',
  async (Id) => {
    const response = await axios.get(`/SetStatusMailUserTypes/${Id}`);
    return response.data;
  }
);

export const setChangeStatusUserTypes = createAsyncThunk(
  '/setChangeStatusUserTypes',
  async (Id) => {
    const response = await axios.get(`/SetChangeStatusUserTypes/${Id}`);
    return response.data;
  }
);

const StatusManagementSlice = createSlice({
  name: 'StatusManagement',
  initialState: {
    loading: false,
    error: '',
    success: false,
    StatusStep: [],
    StatusUserType: [],
    StatusMailUserType: [],
    ChangeStatusStep: [],
    ChangeStatusUserType: [],
    NewWorkOrderCreateStep: [],
    PaymentRules:[]
  },
  reducers: {
    setStatusStep(state, action) {

    },
  },
  extraReducers: {
    [getStatusSteps.pending]: state => {
      state.loading = true;
    },
    [getNewWorkOrderCreateSteps.pending]: state => {
      state.loading = true;
    },

    [getPaymentRules.pending]: state => {
      state.loading = true;
    },
    [getChangeStatusSteps.pending]: state => {
      state.loading = true;
    },
    [getStatusSteps.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getNewWorkOrderCreateSteps.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    [getPaymentRules.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getChangeStatusSteps.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getStatusUserTypes.pending]: state => {
      state.loading = true;
    },
    [getChangeStatusUserTypes.pending]: state => {
      state.loading = true;
    },
    [getStatusUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getStatusMailUserTypes.pending]: state => {
      state.loading = true;
    },
    [getStatusMailUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getStatusMailUserTypes.fulfilled]: (state, action) => {
      state.StatusMailUserType = action.payload;
      state.loading = false;
    },
    [getChangeStatusUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setStatusSteps.pending]: state => {
      state.loading = true;
    },
    [setNewWorkOrderCreateSteps.pending]: state => {
      state.loading = true;
    },
    
    [setPaymentRules.pending]: state => {
      state.loading = true;
    },
    [setChangeStatusSteps.pending]: state => {
      state.loading = true;
    },
    [setStatusSteps.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setNewWorkOrderCreateSteps.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    
    [setPaymentRules.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setChangeStatusSteps.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setStatusUserTypes.pending]: state => {
      state.loading = true;
    },
    [setChangeStatusUserTypes.pending]: state => {
      state.loading = true;
    },
    [setStatusUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setStatusMailUserTypes.pending]: state => {
      state.loading = true;
    },
    [setStatusMailUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [setStatusMailUserTypes.fulfilled]: (state, action) => {
      state.StatusMailUserType = action.payload;
      state.loading = false;
      state.success = true;
    },
    [setChangeStatusUserTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.success = false;
      state.loading = false;
    },
    [getStatusUserTypes.fulfilled]: (state, action) => {
      state.StatusUserType = action.payload;
      state.loading = false;
    },
    [getChangeStatusUserTypes.fulfilled]: (state, action) => {
      state.ChangeStatusUserType = action.payload;
      state.loading = false;
    },
    [getStatusSteps.fulfilled]: (state, action) => {
      state.StatusStep = action.payload;
      state.loading = false;
    },
    [getNewWorkOrderCreateSteps.fulfilled]: (state, action) => {
      state.NewWorkOrderCreateStep = action.payload;
      state.loading = false;
    },

    [getPaymentRules.fulfilled]: (state, action) => {
      state.PaymentRules = action.payload;
      state.loading = false;
    },
    [getChangeStatusSteps.fulfilled]: (state, action) => {
      state.ChangeStatusStep = action.payload;
      state.loading = false;
    },
    [setStatusUserTypes.fulfilled]: (state, action) => {
      state.StatusUserType = action.payload;
      state.loading = false;
      state.success = true;
    },
    [setChangeStatusUserTypes.fulfilled]: (state, action) => {
      state.ChangeStatusUserType = action.payload;
      state.loading = false;
      state.success = true;
    },
    [setStatusSteps.fulfilled]: (state, action) => {
      state.StatusStep = action.payload;
      state.loading = false;
      state.success = true;
    },
    [setNewWorkOrderCreateSteps.fulfilled]: (state, action) => {
      state.NewWorkOrderCreateStep = action.payload;
      state.loading = false;
      state.success = true;
    },

    
    [setPaymentRules.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
    },
    [setChangeStatusSteps.fulfilled]: (state, action) => {
      state.ChangeStatusStep = action.payload;
      state.loading = false;
      state.success = true;
    },
  }
});

export const StatusManagementActions = StatusManagementSlice.actions;

export default StatusManagementSlice;
